export const titleToElementId = (title: string): string => encodeURI(title.toLowerCase().replace(/ /g, '_'));
